import { createFileRoute } from '@tanstack/react-router';

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/_public/portal/user-invite_/$nonceToken_/location_/$locationId')({
  staticData: { team: 'fe-clm' },
});
